module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0015.jpg?v=625ffb2a";